<ng-template ngIf="parcellaStragiudiziale">
    <div class="row">
        <ng-template
            [ngIf]="parcellaStragiudiziale.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
            <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Cognome e nome'"
                [valueInput]="parcellaStragiudiziale.legale?.legale.nominativo"></div>
        </ng-template>
        <ng-template
            [ngIf]="parcellaStragiudiziale.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
            <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Ragione sociale'"
                [valueInput]="parcellaStragiudiziale.legale?.legale.ragioneSociale"></div>
        </ng-template>

        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'N. parcella'"
            [valueInput]="parcellaStragiudiziale.numeroParcella"></div>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Data parcella'"
            [valueInput]="parcellaStragiudiziale.dataParcella | date:'dd/MM/yyyy'"></div>

    </div>


    <div class="container_conteggi">
        <h5>
            <strong>Prospetto finale</strong>
        </h5>
        <div
            *ngFor="let maggiorazioneCalc of [( parcellaStragiudiziale.maggiorazione ?  (parcellaStragiudiziale.importoBase | percentage:parcellaStragiudiziale.maggiorazione) : 0)]">
            <div *ngFor="let totaleCompensi of [( getSum(maggiorazioneCalc, parcellaStragiudiziale.importoBase ))]">
                <div
                    *ngFor="let cassAvvocati of [( parcellaStragiudiziale.flagCpa ?  (totaleCompensi| percentage:parcellaStragiudiziale.cpa.valore) : 0)]">
                    <div
                        *ngFor="let speseGen of [( parcellaStragiudiziale.spesa.percSpesaGenerale ? (totaleCompensi | percentage : parcellaStragiudiziale.spesa.percSpesaGenerale) : 0  )]">
                        <div
                            *ngFor="let totaleImponibile of [(  getSum(totaleCompensi, speseGen,
                                           ( parcellaStragiudiziale.spesa ? parcellaStragiudiziale.spesa.spesaTrasferta : 0),
                                           ( parcellaStragiudiziale.spesa ? parcellaStragiudiziale.spesa.altraSpesaImponibile : 0),cassAvvocati )	)]">

                            <div
                                *ngFor="let iva of [( parcellaStragiudiziale.flagIva ?  (totaleImponibile | percentage:parcellaStragiudiziale.iva.valore) : 0)]">
                                <div
                                    *ngFor="let ipotesiCompenso of [(  getSum(totaleImponibile , parcellaStragiudiziale.spesa?.spesaEsente, parcellaStragiudiziale?.contributoUnificato)  )]">
                                    <div
                                        *ngFor="let ritenutaAcconto of [( parcellaStragiudiziale.flagCpa ?  (getDifRitenutaAcconto(totaleImponibile, cassAvvocati) | percentage:20) : 0)]">
                                        <div
                                            *ngFor="let ritenutaAccontoSFlag of [( (!parcellaStragiudiziale.flagCpa) ?  (totaleImponibile  | percentage:20):0)]">

                                            <div labelTextInput [labelInput]="'Compenso'"
                                                [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="parcellaStragiudiziale.importoBase"></div>

                                            <div labelTextInput
                                                [labelInput]="'Maggiorazione p.d. ' + (parcellaStragiudiziale.maggiorazione ? parcellaStragiudiziale.maggiorazione : 0) + '%'"
                                                [typeLabel]="'conteggioProspetto'" [valueInput]="maggiorazioneCalc">
                                            </div>
                                            <div labelTextInput [labelInput]="'Totale compensi'"
                                                [typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleCompensi">
                                            </div>
                                            <div *ngIf="speseGen" labelTextInput
                                                [labelInput]="'Spese generali art.2 ('+parcellaStragiudiziale.spesa.percSpesaGenerale+'% sul compenso totale)'"
                                                [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="speseGen.replace(',','.')"></div>

                                            <div *ngIf="parcellaStragiudiziale.spesa.spesaTrasferta > 0" labelTextInput
                                                [labelInput]="'Spese di trasferta'" [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="parcellaStragiudiziale.spesa?.spesaTrasferta"></div>

                                            <div *ngIf="parcellaStragiudiziale.spesa.altraSpesaImponibile > 0"
                                                labelTextInput
                                                [labelInput]="'Altre spese imponibili non relative a trasferte'"
                                                [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="parcellaStragiudiziale.spesa?.altraSpesaImponibile"></div>

                                            <div *ngIf="parcellaStragiudiziale.flagCpa" labelTextInput
                                                [labelInput]="'Cassa avvocati ('+parcellaStragiudiziale.cpa.valore+'%)'"
                                                [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="cassAvvocati.replace(',','.')"></div>

                                            <div labelTextInput [labelInput]="'Totale imponibile'"
                                                [typeLabel]="'conteggioProspettoBold'"
                                                [valueInput]="totaleImponibile.replace(',','.')"></div>

                                            <div *ngIf="parcellaStragiudiziale.flagIva" labelTextInput
                                                [labelInput]="'IVA '+parcellaStragiudiziale.iva.valore+'% su imponibile'"
                                                [typeLabel]="'conteggioProspetto'" [valueInput]="iva.replace(',','.')">
                                            </div>

                                            <div *ngIf="parcellaStragiudiziale.spesa.spesaEsente > 0" labelTextInput
                                                [labelInput]="'Spese esenti ex art. 15 DPR 633/72'"
                                                [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="parcellaStragiudiziale.spesa?.spesaEsente"></div>

                                            <div *ngIf="parcellaStragiudiziale.contributoUnificato > 0" labelTextInput
                                                [labelInput]="'Contributo unificato'" [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="parcellaStragiudiziale.contributoUnificato"></div>

                                            <div labelTextInput [labelInput]="'Totale IVA esclusa'"
                                                [typeLabel]="'conteggioProspettoBold'"
                                                [valueInput]="ipotesiCompenso.replace(',','.')"></div>

                                            <div *ngIf="parcellaStragiudiziale.flagRitenutaAcconto  && parcellaStragiudiziale.flagCpa"
                                                labelTextInput
                                                [labelInput]="'A dedurre ritenuta di acconto 20% (su compenso e spese imponibili)'"
                                                [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="ritenutaAcconto.replace(',','.')"></div>

                                            <div *ngIf="parcellaStragiudiziale.flagRitenutaAcconto  && !parcellaStragiudiziale.flagCpa"
                                                labelTextInput
                                                [labelInput]="'A dedurre ritenuta di acconto 20% (su compenso e spese imponibili)'"
                                                [typeLabel]="'conteggioProspetto'"
                                                [valueInput]="ritenutaAccontoSFlag.replace(',','.')"></div>

                                            <div labelTextInput [labelInput]="'Totale IVA inclusa (se applicata)'"
                                                [typeLabel]="'conteggioProspettoBold'"
                                                [valueInput]="parcellaStragiudiziale.importoParcella"></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-template>